import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import * as parentAdmin from "../../../services/parentAdmin.service";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_50, MENU_LOCATION, showFilterList } from "../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const ParentAdminEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation()

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Parent admin"), url: "/admin/user-management/parent-admins/list/1" },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    parentAdmin
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data?.data ? data.data : []);
        // console.log("data--->", data.data);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (<Formik
        enableReinitialize
        validateOnBlur={true}
        validateOnChange={true}
        initialValues={{
          firstName: showdefault && showdefault.firstName ? showdefault.firstName : "",
          lastName: showdefault && showdefault.lastName ? showdefault.lastName : "",
          status:
            showdefault && showdefault.status,
          email:
            showdefault && showdefault.email ? showdefault.email : "",
          phone_number: showdefault && showdefault.phone_number ? showdefault.phone_number : "",
        }}
        validate={(values) => {
          const error = {};

          // Trim all necessary string fields first
          const firstName = values.firstName?.trim() || "";
          const lastName = values.lastName?.trim() || "";
          const phone_number = values.phone_number?.trim() || "";

          // Title Validation
          if (firstName && firstName.length > INPUT_LENGTH_50)
            error.firstName = t("validation_err_reached_maximum_length");

          // Slug Validation
          if (lastName && lastName.length > INPUT_LENGTH_50)
            error.lastName = t("validation_err_reached_maximum_length");

          // Status Validation
          if (!values.status) error.status = t("validation_err_status_required");

          // Menu Location Validation
          if (!values.email) error.email = t("label_email_error");

          // Phone Validation
          // CHANGED: phone empty check, phir minimum 6 digit, phir maximum 10 digit check
          // if (!phone_number) error.phone_number = t("label_phone_error");
          // else if (phone_number.length > 10 && phone_number.length < 6) error.phone_number = t("validation_err_phone_max_length"); 
          if (!phone_number) {
            error.phone_number = t("label_phone_error");
          } else if (phone_number.length < 10) {
            error.phone_number = "Minimum 10 digits required";
          } else if (phone_number.length > 13) {
            error.phone_number = "Maximum 13 digits allowed";
          }

          return error;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          globalLoader(true);
          const id = params.id;
          let formData = new FormData();
          formData.append("firstName", values.firstName);
          formData.append("lastName", values.lastName);
          formData.append("status", values.status);
          formData.append("email", values.email);
          formData.append("phone_number", values.phone_number);

          parentAdmin
            .Edit(formData, id)
            .then((response) => {
              setSubmitting(false);
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
                if (saveType !== "Save") {
                  setTimeout(() => {
                    resetForm({ values: "" });
                    globalLoader(false);
                    navigate(`/admin/user-management/parent-admins/list/1`);
                  }, 1000);
                }
                if (saveType === "Save") {
                  setTimeout(() => {
                    globalLoader(false);
                  }, 1000);
                }
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
                globalLoader(false);
              }
            })
            .catch((error) => {
              console.log("error ====> ", error);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row row-sm">
              <div className="col-lg-12 col-md-12 animation_fade">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="main-content-label mb-3">Parent Admin Edit</h6>
                    </div>
                    {showdefault && Object.keys(showdefault).length > 0 ? (
                      <div className="row row-sm">

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="firstName" className="text-left d-flex">
                            {t("label_first_name")}:
                          </label>
                          <input
                            name="firstName"
                            id="firstName"
                            type="text"
                            placeholder="Enter the first name"
                            // CHANGED: onChange mein setFieldTouched call kiya taaki touched true ho aur
                            // validateOnChange ke saath likhte likhte hi error visible ho jaye
                            onChange={(e) => {
                              setFieldTouched("firstName", true, false);
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            value={values.firstName}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.firstName && touched.firstName && errors.firstName}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="lastName" className="text-left d-flex">
                            {t("label_last_name")}:
                          </label>
                          <input
                            name="lastName"
                            id="lastName"
                            type="text"
                            placeholder="Enter the last name"
                            // CHANGED: onChange mein setFieldTouched call kiya taaki touched true ho aur
                            // validateOnChange ke saath likhte likhte hi error visible ho jaye
                            onChange={(e) => {
                              setFieldTouched("lastName", true, false);
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            value={values.lastName}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.lastName && touched.lastName && errors.lastName}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="status" className="text-left d-flex">
                            {t("list_heading_status")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="status"
                              id="status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.status}
                              className="form-control" >
                              {(showFilterList).map((value, i) => {
                                return (
                                  <option key={i} value={value.status__id}>{t(`${value.name}`)}</option>
                                )
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.status &&
                              touched.status &&
                              errors.status}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="email" className="text-left d-flex">
                            {t("label_email")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="email"
                            id="email"
                            type="text"
                            placeholder="Enter the email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            disabled={"disabled"}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.email && touched.email && errors.email}
                          </span>
                        </div>

                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_tags"
                            className="text-left d-flex"
                          >
                             {t("meta_tags")}:{" "}
                          </label>
                          <textarea
                            name="meta_tags"
                            id="meta_tags"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_tags}
                            className="form-control"
                          />
                        </div> */}
                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_keyword"
                            className="text-left d-flex"
                          >
                             {t("meta_keywords")}:{" "}
                          </label>
                          <textarea
                            name="meta_keyword"
                            id="meta_keyword"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_keyword}
                            className="form-control"
                          />
                        </div> */}
                        <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="phone_number"
                            className="text-left d-flex"
                          >
                            {t("label_phone_number")}:
                            <span className="requirestar">*</span>{" "}
                          </label>

                          <input
                            name="phone_number"
                            id="phone_number"
                            type="text"
                            placeholder="Enter the phone number"
                            value={values.phone_number}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\D/g, "");
                              setFieldTouched("phone_number", true, false);
                              setFieldValue("phone_number", val);
                            }}
                            onBlur={handleBlur}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.phone_number &&
                              touched.phone_number &&
                              errors.phone_number}
                          </span>
                        </div>

                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
      ) : (
        <Loader />
      )}

    </>
  );
};

export default ParentAdminEdit;